import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPaymentGateway } from '../../services'
import { BankQueryKeys } from '@/modules/bank/keys'
import {
	GetPaymentGateWayRequest,
	GetPaymentGateWayResponse,
} from '@/modules/bank/type'

export default function useQueryGetPaymentGateway(
	payload: GetPaymentGateWayRequest,
	props?: UseBaseQueryOptions<GetPaymentGateWayResponse>,
) {
	return useQuery({
		queryKey: [BankQueryKeys.PaymentGateways, payload],
		queryFn: () => getPaymentGateway(payload),
		...props,
	})
}
